import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

export const usePresenter = () => {
  const { dispatch, fenceStore } = useStoreon<IState, IEvents>('fenceStore');

  const pailingCoatingHandler = (pailingCoating: string) => {
    dispatch('fence/set-pailing-coating', { pailingCoating });
  };
  const pailingTypeHandler = (pailingType: string) => {
    dispatch('fence/set-pailing-type', { pailingType });
  };
  const pailingPBarHandler = (pailingPBar: string) => {
    dispatch('fence/set-pailing-pbar', { pailingPBar });
  };

  return {
    pailingCoating: fenceStore.pailingCoating,
    pailingType: fenceStore.pailingType,
    pailingPBar: fenceStore.pailingPBar,
    pailingCoatingHandler,
    pailingTypeHandler,
    pailingPBarHandler,
  };
};
